import styled from "styled-components";
import { keyframes } from 'styled-components';

export const spin = keyframes`
  to { transform: rotate(360deg); }
`;
// Styled components
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
`;

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px 32px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 360px;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 0 0 8px;
`;

export const Subtitle = styled.p`
  font-size: 13px;
  color: #888;
  margin: 0 0 24px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  box-sizing: border-box;
  margin-bottom: 12px;

  &:focus {
    border-color: #333;
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 12px;
  background: #222;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #444;
  }

  &:disabled {
    background: #aaa;
    cursor: not-allowed;
  }
`;

export interface StatusMessageProps {
  $success: boolean;
}

export const StatusMessage = styled.p<StatusMessageProps>`
  margin: 16px 0 0;
  font-size: 13px;
  color: ${({ $success }) => ($success ? '#38a169' : '#e53e3e')};
`;

export const ExistingBadge = styled.div`
  display: inline-block;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #166534;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  margin-bottom: 20px;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #eee;
  border-top-color: #333;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin: 0 auto 16px;
`;

export const SuccessIcon = styled.div`
  font-size: 40px;
  color: #38a169;
  margin-bottom: 12px;
`;

export const ErrorIcon = styled.div`
  font-size: 40px;
  color: #e53e3e;
  margin-bottom: 12px;
`;